<template>
<div class="blackBox">
    <div class="divButtonRigth" style="margin-bottom: 20px">
        <el-button type="primary" size="small" @click="showAddDailog">新增</el-button>
        <el-button type="success" size="small" @click="changeStatus('1')">启用</el-button>
        <el-button type="danger" size="small" @click="changeStatus('0')">禁用</el-button>
        <el-button type="primary" size="small" @click="initRedisParameter">初始化缓存</el-button>
        <el-button type="primary" size="small" @click="exportTableData">导出</el-button>
        <el-button type="primary" size="small" @click="backToCodeSet">返回</el-button>
    </div>

    <bsp-table
    ref="sysCodeItemTable"
    :data.sync="list"
    :ciic-data-filter.sync="listQuery"
    @ciic-data-refresh="_getCodeItemListPage"
    @select-change="selectChange"
    @select-all="selectChange"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    >
        <vxe-table-column type="selection" width="60" fixed="left" align="center" ></vxe-table-column>
        <vxe-table-column title="序号" type="index" width="60" fixed="left" align="center"></vxe-table-column>
        <bsp-table-column
        title="代码编号"
        field="codeItemId"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.codeItemId}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="代码项名称"
        field="codeItemName"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.codeItemName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="英文名称"
        field="codeItemEnName"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.codeItemEnName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="拼音"
        field="codeItemSpell"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.codeItemSpell}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="简称"
        field="codeItemEnName"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.codeItemEnName}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="值"
        field="codeItemCompareValue"
        filter-type="input"
        >
        <template slot-scope="scope">
            <span>{{scope.row.codeItemCompareValue}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="状态"
        field="codeItemStatus"
        filter-type="select"
        :options-type="status"
        >
        <template slot-scope="scope">
        <!-- <el-switch
        style="display: block"
        v-model="scope.row.codeItemStatus"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="启用"
        active-value="1"
        inactive-value="0"
        >
        </el-switch> -->
            <span>{{scope.row.codeItemStatus | dictListFilter(status)}}</span>
        </template>
        </bsp-table-column>

        <bsp-table-column
        title="操作"
        >
        <template slot-scope="scope">
                <div class="ciic-table-operate">
                  <el-button size="small" type="text" @click="showUpdateDialog(scope.row)">
                    <i class="el-icon-edit el-icon--right"></i>编辑
                  </el-button>
                  <el-button size="small" v-show="scope.row.codeSetId==='0306'" type="text" @click="showCompareValueEditDialog(scope.row)">
                    <i class="el-icon-edit el-icon--right"></i>编辑基值
                  </el-button>
            </div>
        </template>
        </bsp-table-column>
    </bsp-table>
  <!-- 编辑基值弹窗 -->
  <el-dialog title="编辑基值" :visible.sync="compareValueEditShow" :close-on-click-modal="false" width="600px" append-to-body @closed="compareValueEditClosed" v-dialog-drag top="2vh">
    <el-form ref="compareValueEditForm" class="air-form" :model="compareValueEditForm" style="height: 375px;" size="small">
      <div class="air-modal-body flex vertical" style="height: 175px;">
        <air-table
          ref="airTableCompareValue"
          :loading="loadingCompareValue"
          :columns="columnsCompareValue"
          :data="tableDataCompareValue"
          :show-checkbox="false"
          :show-operation="false"
          :show-export-seq="false"
          align="center"
          @cell-click="handleCellClick"
        >
        </air-table>
      </div>
      <div class="emp-form-group">
        <el-row :gutter="80" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item label="字典编号" prop="codeItemId">
              <el-input v-model="tableDataCompareDetailValue.codeItemId" placeholder="请输入字典编号" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字典名称" prop="codeItemName">
              <el-input v-model="tableDataCompareDetailValue.codeItemName" placeholder="请输入字典名称" maxlength="30" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item label="基值" prop="codeItemValue">
              <el-input v-model="tableDataCompareDetailValue.codeItemValue" placeholder="请输入基值" maxlength="30" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效时间" prop="effectDate">
              <el-input v-model="tableDataCompareDetailValue.effectDate" placeholder="请输入生效时间" maxlength="30" />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div slot="footer" class="air-modal-footer flex jend acenter">
      <el-button type="text" class="text-button-cancel" @click="compareValueEditShow = false">取消</el-button>
      <el-button :loading="loadingCompareValue" type="primary" @click="submitCompareValueEditForm">修改</el-button>
      <el-button :loading="loadingCompareValue" type="primary" @click="submitCompareValueAddForm">新增</el-button>
      <el-button :loading="loadingCompareValue" type="primary" @click="submitCompareValueDeleteForm">删除</el-button>
    </div>
  </el-dialog>
  
    <sys-code-item-dialog
      ref="dialogForm"
      :status="status"
      :dialog-status="dialogStatus"
      :dialog-form-visible.sync="dialogFormVisible"
      :list-form="listForm"
      :row-code-set-id="this.$route.query.setId"
      @data-refresh="_getCodeItemListPage"
      >
    </sys-code-item-dialog>
</div>
</template>

<script>
import {getCodeItemListPage,changeCodeItemStatus,recacheCodeItem,sysCodeItemQxValueList,sysCodeItemQxValueUpdate,sysCodeItemQxValueAdd,sysCodeItemQxValueDelete} from '@/api/sys/code'
import BspTable from "@/components/bsp/bsp-table/bsp-table";
import BspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
import SysCodeItemDialog from "@/views/sys/code/SysCodeItemDialog.vue";
import exportMethod from "@/util/export"
export default {
    name: 'SysCodeItem',
    components: {
        BspTable,
        BspTableColumn,
        SysCodeItemDialog
    },
    created() {
        this._getCodeItemListPage()
    },
    data() {
        return {
            loading: false,
            // 弹框状态
            dialogStatus: 'add',
            dialogFormVisible: false,
            listForm:{},
            //分页查询对象
            listQuery: {
                limit: 20,
                page: 1,
                total: 0,
                codeSetId: this.$route.query.setId
            },
            list:[],
            multipleSelection: [],
            status:[
                {codeItemName:'禁用',codeItemId:'0'},
                {codeItemName:'启用',codeItemId:'1'}
            ],
          compareValueEditShow: false,
          compareValueEditForm: {},
          loadingCompareValue: false,
          tableDataCompareValue: [],
          columnsCompareValue: [
            {title: '字典编号', field: 'codeItemId', minWidth: 120},
            {title: '字典名称', field: 'codeItemName', minWidth: 120},
            {title: '基值', field: 'codeItemValue', minWidth: 150},
            {title: '生效时间', field: 'effectDate', minWidth: 120},
            {title: '修改时间', field: 'updateTime', minWidth: 140}
          ],
          tableDataCompareDetailValue:{},
          codeItemRow:{}
        }
    },
    methods: {
        //批量更改状态
        selectChange({checked, row}){
          if(checked&&row!=undefined){
            this.multipleSelection.push(row)
          }else if(checked){
            this.multipleSelection=JSON.parse(JSON.stringify(this.list))
          }
          if(!checked&&row!=undefined){
            this.multipleSelection.filter((item,index) => {
              if(item===row){
              this.multipleSelection.splice(index,1)
            }
          })
          }else if(!checked){
            this.multipleSelection=[]
          }
        },
        // 分页查询
        _getCodeItemListPage() {
          this.loading=true
          this.$set(this.listQuery)
          getCodeItemListPage(this.listQuery).then((res) => {
            this.listQuery.total=res.data.total
          this.list=res.data.records
          this.loading=false
        });
        },
        changeStatus(status){

            let listSize=this.multipleSelection.length
            if(listSize==0){
                this.$message.error('请选择至少选中一行')
            }else{
                let param={
                    multipleSelection: this.multipleSelection,
                    status: status
                }
                changeCodeItemStatus(param).then(res =>{
                    if(res.data.code==0){
                      this.$message.success('操作完成')
                    }else{
                      this.$message.error('操作失败')
                    }
                });
              this._getCodeItemListPage();
            }
        },

        backToCodeSet(){
            this.$router.go(-1)
        },
        
        showAddDailog() {
          this.listForm = {
          };
          this.dialogFormVisible = true;
          this.dialogStatus = 'add';
        },
        showUpdateDialog(row) {
          this.listForm = JSON.parse(JSON.stringify(row));
          this.dialogFormVisible = true;
          this.dialogStatus = 'update';
        },
        // 导出到excel
        exportTableData () {
          exportMethod(
            {
              columns: this.$refs['sysCodeItemTable'].tableColums,
              ...this.listQuery,
              type: "excel",
              beanName: "codeServiceImpl",
              methodName: "queryCodeItemList",
              headerRowNum: 2,
              fileName: "参数表格数据.xls",
              fileType: ".xls",
            },
            "/sys",true
          );
        },
        // 初始化到缓存
        initRedisParameter() {
          let listSize=this.multipleSelection.length
          if(listSize==0){
            this.$message.error('请选择至少选中一行')
          }else{
            let param={
              multipleSelection: this.multipleSelection
            }
            recacheCodeItem(param).then(res =>{
              if(res.data.code==0){
              this.$message.success('操作完成')
            }else{
              this.$message.error('操作失败')
            }
          })
          }
        },
      showCompareValueEditDialog(row){
        this.codeItemRow = row
        this.compareValueEditShow = true
        this.loadingCompareValue=true
        const params = {
          codeItemId: row.codeItemId
        }
        sysCodeItemQxValueList(params).then((res) => {
          this.tableDataCompareValue = res.data.data
          this.tableDataCompareDetailValue = {}
          this.loadingCompareValue = false
        }).catch(() => {
          this.$msgSuccess('操作失败，请稍后重试。')
          this.loadingCompareValue = false
        })
      },
      compareValueEditClosed(){
        this.compareValueEditShow = false
      },
      submitCompareValueEditForm(){
        this.loadingCompareValue=true
        const params = {
          ...this.tableDataCompareDetailValue
        }
        sysCodeItemQxValueUpdate(params).then((res) => {
          if(res.data.code===0)
          {
            this.tableDataCompareDetailValue = {}
            this.showCompareValueEditDialog(this.codeItemRow)
          }
          this.loadingCompareValue = false
        }).catch(() => {
          this.$msgSuccess('操作失败，请稍后重试。')
          this.loadingCompareValue = false
        })
      },
      submitCompareValueAddForm(){
        this.loadingCompareValue=true
        const params = {
          ...this.tableDataCompareDetailValue
      }
        sysCodeItemQxValueAdd(params).then((res) => {
          if(res.data.code===0)
        {
          this.tableDataCompareDetailValue = {}
          this.showCompareValueEditDialog(this.codeItemRow)
        }
        this.loadingCompareValue = false
      }).catch(() => {
          this.$msgSuccess('操作失败，请稍后重试。')
        this.loadingCompareValue = false
      })
      },
      submitCompareValueDeleteForm(){
        this.loadingCompareValue=true
        const params = {
          ...this.tableDataCompareDetailValue
      }
        sysCodeItemQxValueDelete(params).then((res) => {
          if(res.data.code===0)
          {
            this.tableDataCompareDetailValue = {}
            this.showCompareValueEditDialog(this.codeItemRow)
          }
          this.loadingCompareValue = false
        }).catch(() => {
            this.$msgSuccess('操作失败，请稍后重试。')
          this.loadingCompareValue = false
        })
        },
        handleCellClick({ row, column, cell, event }){
        this.tableDataCompareDetailValue=row
      },
    },
    computed: {

    }
}
</script>

<style lang="scss">
#teanant-select{
  width: 100px;
}
.emp-form-group {
  border-bottom: 1px solid #DDDDDD;
  margin-bottom: 20px;
}
</style>
